import React from 'react'

import { List, ListItem, Typography, Box, Divider, Button } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import useBrand from './useBrand'

import { Themes } from '../../theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuListItem: {
      height: '80px',
    },
    actualBrand: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    actualBrandTitle: {
      margin: `${theme.spacing(1)}px 0`,
    },
    actualBrandLogo: {
      margin: `${theme.spacing(1)}px 0`,
    },
    availableBrandsList: {
      padding: 0,
      flexBasis: '100%',
    },
    availableBrand: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 0',
    },
  }),
)

interface BrandMenuProps {
  theme: string
  onChangeBrand: (brand: string) => void
}

export default function BrandMenu({ onChangeBrand, theme }: BrandMenuProps) {
  const classes = useStyles()
  const { selectedBrand, availableBrands } = useBrand(theme)

  const changeBrand = (brand: string) => {
    const typedBrand = brand as keyof typeof Themes
    onChangeBrand(typedBrand)
  }

  return (
    <>
      <ListItem
        className={`${classes.actualBrand} ${classes.menuListItem}`}
        data-hook={`brand-menu-selected-${selectedBrand.id}`}
      >
        <Typography className={classes.actualBrandTitle} variant="body2">
          Marca actual seleccionada:
        </Typography>
        <Box className={classes.actualBrandLogo}>{selectedBrand.logo}</Box>
      </ListItem>
      <Divider />
      <ListItem>
        <List component="div" className={classes.availableBrandsList}>
          <Typography className={classes.actualBrandTitle} variant="body2">
            Otras marcas disponibles:
          </Typography>
          {Object.keys(availableBrands).map((brand) => {
            return (
              <div
                key={brand}
                className={classes.availableBrand}
                data-hook={`brand-menu-option-${brand}`}
              >
                {availableBrands[brand].logo}
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => changeBrand(brand)}
                >
                  Seleccionar
                </Button>
              </div>
            )
          })}
        </List>
      </ListItem>
    </>
  )
}
